export const SET_OPEN_DOWNLOAD = 'SET_OPEN_DOWNLOAD';
